<template>
  <div class="config-wrapper">
    <div class="config-top config-inside-wrapper">
      <button
        type="button"
        v-if="allSelectionsMade"
        @click="finalizeDesign"
        class="btn btn--inverse btn--right config-wrapper__mobile-done-btn"
        data-text="You're Done! Review &amp; Finalize"
      >You're done! Review &amp; Finalize</button>
      <div class="config-canvas-wrapper">
        <div class="config-canvas-equalizer">
          <router-view name="canvas"/>
        </div>
      </div>
      <div class="config-nav-wrap">
        <ConfigNavigation/>
      </div>
    </div>

    <div class="config-options" :class="{'config-options--text': isTextPage() }">
      <transition name="slideup">
        <div class="config-options-wrapper" v-show="showme">
          <router-view name="canvasOptions"/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../eventBus";
import * as EmojiStrip from "emoji-strip";
import store from "../store";
import ConfigNavigation from "../components/ConfigNavigation.vue";

export default {
  name: "custom",
  data() {
    return {
      showme: false
    };
  },
  created() {
    $(document).ready(function() {
      let resizeTimeout = null;
      const div = document.querySelector(".config-canvas-wrapper");
      // run once
      actualResizeHandler();

      function resizeThrottler() {
        if (!resizeTimeout) {
          resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
          }, 66);
        }
      }

      function actualResizeHandler() {
        let hei = $(div).height();
        let wid = hei - 73;
        if (window.innerWidth >= 992) {
          $(div).attr("style", "");
        } else {
          $(div).width(wid);
        }
      }
      window.addEventListener("resize", resizeThrottler, false);
    });
  },
  computed: {
    productOptions() {
      return store.state.productOptions;
    },
    hasTextError() {},
    allSelectionsMade() {
      const {
        CustomText,
        Fabric,
        Caps,
        Icon,
        Spine,
        Loop
      } = store.state.configuration;
      if (Fabric && Caps && Icon && Spine && Loop && CustomText !== null) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    document.querySelector("html").classList.add("full-page");
    this.showme = true;
    store.dispatch("getProducts").then(() => {
      store.dispatch("getProductOptions", {
        productId: store.state.productBeingConfigured.Id
      });
    });
  },
  methods: {
    isTextPage() {
      if (this.$route.name === "CustomText") {
        return true;
      }
      return false;
    },
    finalizeDesign() {
      let moveOn = false;
      const inputText = this.$store.state.inputText;
      if (inputText === null) {
        // change to an empty string
        this.$store.commit("updateCustomText", "");
        moveOn = true;
      } else if (inputText !== this.$store.state.configuration.CustomText) {
        const myText = EmojiStrip(inputText.trim().toUpperCase());
        const hasBadWord = this.$store.state.forbiddenText.some(
          bad => myText.indexOf(bad) > -1
        );
        if (hasBadWord) {
          // show error and do not change pages
          console.error("Text contains forbidden words. Please correct.");
          EventBus.$emit("textError", true);
          moveOn = false;
        } else {
          this.$store.commit("updateCustomText", this.$store.state.inputText);
          EventBus.$emit("textError", false);
          moveOn = true;
        }
      } else {
        moveOn = true;
      }
      if (moveOn) {
        this.$router.push({ name: "completed-design" });
      }
    }
  },
  components: { ConfigNavigation }
};
</script>


<style lang="scss" scoped>
.config-wrapper {
  box-sizing: border-box;
  padding-top: 75px;
  @media (min-width: 992px) {
  }
  &__mobile-done-btn {
    display: flex;
    text-align: center;
    position: absolute;
    top: 60%;
    z-index: 2;
    left: 50%;
    width: calc(100% - 2em - 40px);
    max-width: 300px;
    transform: translate3d(-50%, -50%, 0);
    @media (min-width: 992px) {
      display: none;
    }
  }
}
.config-top {
  position: relative;
  @media (min-width: 992px) {
    position: static;
    height: calc(100vh - 136px - 95px);
  }
}
.config-inside-wrapper {
  @media (min-width: 992px) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    @media (min-height: 610px) {
      align-items: center;
    }
  }
}
.config-options-wrapper {
}

.config-canvas-equalizer {
  @media (max-width: 991px) {
    height: calc(100vh - 100px - 73px - 75px - 112px);
    width: 0;
    padding-right: 80.39407%;
    position: relative;
    margin: auto;
    @media (min-width: 768px) {
      padding-right: 78.39407%;
    }
    > * {
      height: 100%;
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
  @media (max-width: 767px) {
    height: calc(100vh - 100px - 73px - 75px - 112px); // 100px - 73px - 75px
  }
}
.config-options {
  grid-column: 1 / span 3;
  background: #fff;
  height: 100px;
  transition: opacity 1s;
  overflow-y: hidden;
  @media (min-width: 992px) {
    height: auto;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    min-height: 132px;
  }
}
.slideup-enter-active,
.slideup-leave-active {
  transition: opacity 0.2s, transform 0.5s;
  transition-delay: 1s; // after the other animations in ConfigNavigation
}

.slideup-enter,
.slideup-leave-to {
  opacity: 0;
  transform: translateY(50px);
}

.config-canvas-wrapper {
  position: relative;

  @media (max-width: 991px) {
    max-width: 100%; // 500px
    width: calc(90vh - 75px - 73px - 100px);
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 767px) {
    width: calc(90vh - 362px);
  }
  @media (min-width: 992px) {
    width: 60vh; // 100%
    max-width: 550px; // 745
    align-self: flex-start;
    @media (min-height: 950px) {
      align-self: center;
    }
  }
}
.config-nav-wrap {
  @media (min-width: 992px) {
    max-width: 32%;
    width: 100%;
    margin-left: 145px;
  }
}
</style>